import React, {  useState } from 'react'
import logo from "../asstes/logo.svg";
import { Link , useLocation} from 'react-router-dom';
import styles from '../styles';
import { FaBars } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import LanguagesDrop from './LanguagesDrop';
import { useTranslation } from 'react-i18next';

const Header = ({dis}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const location = useLocation(); // Get the current route
    const [nav , setNav] = useState(false);
    const [active , setActive] = useState(location)
    const links = t('header.links', { returnObjects: true });
    const reservation = t('header.reservation', { returnObjects: true });
      const handleChange = (e) => {
        setActive(e);
      }
      // Map language codes to country codes for flags
      const languageToCountry = {
        fr: 'FR', // France
        en: 'US', // United States
        ar: 'MA'  // Morocco
      };
    
      // Get current flag based on selected language
      const getCurrentFlag = () => {
        const countryCode = languageToCountry[i18n.language] || 'FR';
        return `https://flagsapi.com/${countryCode}/flat/64.png`;
      };
  return (
    <div className={`${isRTL? 'rtl' : 'ltr'} w-full ${isRTL ? '!font-cairo' : 'font-manrope'}  py-3 bg-primary02 ${dis ? 'rounded-[0] px-2 sm:px-4  justify-between' : 'rounded-[12px] justify-around'} flex  items-center`}>
        <div className={` ${dis ? 'w-1/2' : 'w-auto'} flex justify-start items-center`}>
          <Link to={'/home'} smooth duration={500}>
            <img className={`${dis ? 'w-[60%]'  :'w-[100%]'} h-auto `} src={logo} alt='Logo'/>
          </Link>
        </div>
        <div className={`${dis ? 'hidden' : 'flex'} justify-between items-center`}>
            <ul className='flex gap-[48px] xxxl:gap-20' >
            {
                links.map(({id , link , name}) => (
                <li key={id} className={`${styles.headerlinks} ${location.pathname === `/`+link && 'text-secondary border-b-secondary border-b-solid border-b-[2px] !font-bold'}`} onClick={() => {handleChange(link)}}>
                    <Link to={link} smooth duration={500}>{name}</Link>
                </li>
                ))
            }
            </ul>
        </div>
        <div className={`${dis ? 'block' : 'hidden'} flex gap-2 items-center`}>
          <div className='languages  flex items-center gap-2'>
            <img 
              src={getCurrentFlag()} 
              alt="Selected Language Flag" 
              className="w-10 h-10 object-cover"
            />
            <LanguagesDrop w={20} className='bg-primary text-white' classN='text-white data-[focus]:bg-primary data-[focus]:text-white' classN1='bg-primary'/>
          </div>
          <div className={` cursor-pointer z-10 flex gap-2`} onClick={() => {setNav(!nav)}}>
            {nav ? <FaTimes size={30} fill='#1376F8'/> : <FaBars size={30}  fill='#1376F8'/>}
          </div>
        </div>

        {nav && 
          <ul className='flex flex-col justify-center gap-16 items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-primary02 via-primary02 to-primary opacity-95 transform transition-all duration-500'
           >
          {
              links.map(({id , link, name}) => (
              <li key={id} className={`${styles.headerlinksmobile} ${location.pathname === `/`+link ? 'text-secondary !font-bold' : 'opacity-70'}`} onClick={() => {handleChange(link); setNav(!nav)}}>
                  <Link to={link} smooth duration={500}>{name}</Link>
              </li>
              ))
          }
          </ul>
        }
        <div className={`${dis ? 'hidden' : 'flex w-auto'} items-center justify-end`}>
            <button className={`${styles.primaryBotton} `}>
                <Link to={'contact'} smooth duration={50}>{reservation}</Link>
            </button>
        </div>
    </div>
  )
}

export default Header